import { FC } from 'react';
import { PrimaryButtonProps } from './types';

const PrimaryButton: FC<PrimaryButtonProps> = (props) => {
	const baseWidthClass = props.fullButtonPrimary ? 'pop-w-full' : 'pop-w-[20%]';

	return (
		<button
			className={`pop-btn2 pop-text-sm ${
				props.isDisabled
					? 'disabled:pop-bg-popsizeNeutral10 disabled:pop-text-popsizeNeutral20'
					: `pop-bg-popsizeGradientPrimary10 pop-text-popsizePrimary50 hover:pop-bg-popsizePrimary20 ${baseWidthClass} ${props.className ?? ''}`
			}`}
			onClick={props.onClick}
			disabled={props.isDisabled}
		>
			{props.isLoading ? (
				<span className="pop-loading pop-loading-dots pop-loading-md" />
			) : (
				props.children
			)}
		</button>
	);
};

export default PrimaryButton;
